import {NovaTarefa} from "./nova-tarefa";
import {Comentario} from "./comentario";
import {MovimentacaoTarefa} from "./movimentacao-tarefa";

export class TarefaDetalhes extends NovaTarefa{
  id: number;
  responsavel: string;
  dataCadastro: Date;
  status: number;
  tipoTarefa: string;

  comentario: string;
  responsavelId: number;
  solicitanteId: number;
  solicitante: string;
  atrasada:boolean;
  finalizada:boolean;

  comentariosDetalhes: Comentario[];
  movimentacoesDetalhes: MovimentacaoTarefa[];
}
